import { useQuery } from '@tanstack/react-query';

import { teamApi } from '../api';
import {
  TEAM_BOARD_TASKS_QUERY_KEY,
  TeamTasksResult,
  normalizeTeamTaskItem,
} from './teamTasks.shared';

interface UseTeamBoardTasksParams {
  userId: string;
  teamId?: string;
  date?: string;
}

export const useTeamBoardTasks = ({ userId, teamId, date }: UseTeamBoardTasksParams) => {
  const teamBoardTasksQuery = useQuery({
    queryKey: [...TEAM_BOARD_TASKS_QUERY_KEY, { userId, teamId, date }],
    queryFn: () => {
      return teamApi.getTeamBoardTasks(teamId!, date!).then(({ data }) => {
        return {
          date: data.date,
          counts: data.counts,
          tasks: (data.tasks ?? []).map(normalizeTeamTaskItem).filter(Boolean),
        } as TeamTasksResult;
      });
    },
    refetchOnWindowFocus: false,
    enabled: !!userId && !!teamId && !!date,
    staleTime: 5000,
  });

  return {
    teamTasks: teamBoardTasksQuery.data ?? null,
    tasks: teamBoardTasksQuery.data?.tasks ?? [],
    counts: teamBoardTasksQuery.data?.counts ?? null,
    ...teamBoardTasksQuery,
  };
};
